export enum BuildingTabs {
    overview = 'overview',
    documents = 'documents',
    invoices = 'invoices',
    consumption = 'consumption',
    customers = 'customers',
    tickets = 'sak',
    calendar = 'calendar',
}
